
import Vue from 'vue';
import { Utils } from '../utils/Utils';

export default Vue.extend({
    name: 'HouseholdIncomeInput',

    props: {
        title: String,
        content: String,
        input_label: String,
        annualIncome: String,
        maxIncomeChecked: Boolean,
        checkbox_label: String,
        errorMessage: String,
    },

    data() {
        return {
            incomeNativeAttributes: `{"inputmode": "decimal", "pattern": "[0-9]|[1-9][0-9]{1,7}", "data-testid": "household-income-input"}`,
            isInvalid: false,
        };
    },
    methods: {
        handleInput: function (e: any) {
            // check to ensure only one decimal
            Utils.handleInputDecimal(e);
            // check for a numeric key or a decimal or a cmd/ctrl key
            Utils.handleNumberInput(e);
        },
        onPaste: function (e: any) {
            // check if the copied paste is valid
            Utils.handlePasteValid(e);
        },
        handleValueChange: function (event: any) {
            this.isInvalid = false;
            let val =
                event.target.value.trim() === ''
                    ? 0
                    : parseFloat(parseFloat(event.target.value).toFixed(0));
            this.$emit('annualIncomeChanged', val);
        },
        onClickCheckbox: function () {
            this.isInvalid = false;
            this.$emit('maxIncomeChanged', !this.maxIncomeChecked);
        },
        handleIncomeInvalid() {
            this.isInvalid = true;
        },
    },
});
